import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Notification } from '../interfaces/core/notification.entity';
import { getJsDate } from '../utils/date';

type NotificationResponse = Omit<Notification, 'created_at'> & {
	created_at: string;
}

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private baseUrl: string = environment.baseUrl;

	constructor(private http: HttpClient) { }

	getMyNotifications(): Observable<Notification[]> {
		return this.http.get<NotificationResponse[]>(`${this.baseUrl}/core/notifications`).pipe(
			map(notifications => notifications.map(n => ({
				...n,
				created_at: getJsDate(n.created_at, 'ISO')
			})))
		);
	}

	markAsRead(notification_id: string): Observable<string> {
		return this.http.post(`${this.baseUrl}/core/notifications/mark-as-read/${notification_id}`, {}, { responseType: 'text' });
	}
}
